module.exports = __webpack_public_path__ + "static/media/schedule-star.71f4d533.png";